export default __webpack_public_path__ + "static/media/Cookie-policies-tdsa-01.59752898.jpg";